import React, { useState } from "react"
import ClientsHeader from "./controllers/ClientsHeader.controller"
import ClientsTable from "./controllers/ClientsTable.controller"
import ModalFormClient from "./controllers/clientForm/ModalFormClient.controller"
import { useLocation } from "react-router-dom"
import { FORM_CLIENT_MODE } from "../../consts/modules/clients.consts"

const Clients = () => {
  const [showClientFormModal, setShowClientFormModal] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const triggerRefresh = () => {
    setRefresh(!refresh)
  }
  const location = useLocation()
  const clientId = location?.state?.clientId
  return (
    <>
      <ClientsHeader setShowClientFormModal={setShowClientFormModal} />
      <ClientsTable refresh={refresh} />
      <ModalFormClient
        visible={showClientFormModal}
        setVisible={setShowClientFormModal}
        triggerRefresh={triggerRefresh}
        mode={FORM_CLIENT_MODE.CREATE}
      />
    </>
  )
}

export default Clients
